export interface IBadge {
  label: string
  variant: string
  color: string
  size: string
}
